module.exports = __webpack_public_path__ + "img/Picture14.b18ae6a9.png";